export interface IFeedItem {
  id: string;
  title: string;
  images?: any;
  totalLikes: string;
  lastModifiedBy: string;
  targetId: string;
  locationId: string;
  type: string;
  targetType: string;
}

export interface IFeedItemImage {
  url: string;
  sizes: IFeedItemImageSize[];
}

export interface IFeedItemImageSize {
  url: string;
  height: number;
}

export interface ICreateFeedItem {
  title: string;
  type: string;
  locationId: string;
  imageId: string;
  targetId: string;
  targetType: string;
}
